module.exports = __webpack_public_path__ + "static/georgina-5c66db2400891647f22cc7aab27303c4.svg";